import { render, staticRenderFns } from "./NewArrowLinePropertyEditor.vue?vue&type=template&id=2bd29bb6&scoped=true&"
import script from "./NewArrowLinePropertyEditor.vue?vue&type=script&lang=ts&"
export * from "./NewArrowLinePropertyEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd29bb6",
  null
  
)

export default component.exports